import { exportPaymentsExcel } from "@/business/payment/application/exportPaymentsExcel";
import { getInvoicesByDay } from "@/business/payment/application/getInvoicesByDay";
import { Payment } from "@/business/payment/domain/payment";
import { ref, Ref, computed } from "vue";
import { cancelPayment } from "@/business/payment/application/cancelPayment";

export function paymentsUse() {
  const route: Ref<string> = ref("");
  const payments: Ref<Payment[]> = ref([]);
  const selectedDate: Ref<string> = ref("");
  const query: Ref<string> = ref("");
  const modalReceipt: Ref<boolean> = ref(false);
  const modalImages: Ref<boolean> = ref(false);
  const modalConfirmCancellation: Ref<boolean> = ref(false);
  const modalReasonCancellation: Ref<boolean> = ref(false);
  const selectedReceiptUrl: Ref<string> = ref("");
  const selectedPayment: Ref<Payment | null> = ref(null);
  const selectedImages: Ref<string[]> = ref([]);
  const message: Ref<string> = ref("");

  async function handleDateChange(event: any) {
    const formatDate = event.target.value.replaceAll("-", "");
    payments.value = await getInvoicesByDay.execute(formatDate);
    selectedDate.value = formatDate;
    route.value = await exportPaymentsExcel.execute(formatDate);
  }

  const filteredPayments = computed(() => {
    let result = payments.value;

    if (query.value.length > 0) {
      result = payments.value.filter((payment) =>
        payment.orderNumber.toString().toLowerCase().includes(query.value.toLowerCase())
      );
    }

    return result;
  });

  function openReceiptModal(payment: Payment): void {
    selectedPayment.value = payment;
    selectedReceiptUrl.value =
      payment.state !== "ANULADO" ? payment.url : payment.cancelUrl;
    modalReceipt.value = true;
  }

  function closeReceiptModal(): void {
    modalReceipt.value = false;
    selectedPayment.value = null;
    selectedReceiptUrl.value = "";
  }

  function openImagesModal(payment: Payment): void {
    selectedPayment.value = payment;
    selectedImages.value = payment.vouchers || [];
    modalImages.value = true;
  }

  function closeImagesModal(): void {
    modalImages.value = false;
    selectedPayment.value = null;
    selectedImages.value = [];
  }

  function manageConfirmCancellationModal(payment: Payment) {
    modalConfirmCancellation.value = true;
    selectedPayment.value = payment;
    message.value =
      "¿Está seguro de anular el pago con factura número " +
      payment.invoceNumber +
      "?";
  }

  function closeConfirmCancellationModal() {
    modalConfirmCancellation.value = false;
  }

  function manageReasonCancellationModal(value: boolean) {
    modalReasonCancellation.value = value;
  }

  function closeReasonCancellationModal() {
    modalReasonCancellation.value = false;
    modalConfirmCancellation.value = false;
  }

  async function nullifyPaymentOperation(comments: string) {
    await cancelPayment.execute(selectedPayment.value?.key ?? "", comments);
    closeReasonCancellationModal();
    payments.value = await getInvoicesByDay.execute(selectedDate.value);
  }

  const isDateSelected = computed(() => {
    return selectedDate.value.length > 0;
  });

  return {
    manageConfirmCancellationModal,
    modalConfirmCancellation,
    closeConfirmCancellationModal,
    manageReasonCancellationModal,
    modalReasonCancellation,
    closeReasonCancellationModal,
    payments,
    selectedDate,
    handleDateChange,
    filteredPayments,
    query,
    route,
    openReceiptModal,
    modalReceipt,
    closeReceiptModal,
    selectedReceiptUrl,
    selectedImages,
    modalImages,
    closeImagesModal,
    openImagesModal,
    isDateSelected,
    nullifyPaymentOperation,
    message,
  };
}
